<section class="content employees-page">
  <div class="content-block employees-page__content">
    <div class="block-header employees-page__header">
      <app-breadcrumb [title]="'MENUITEMS.ORGANIZATION.TEXT' | translate"
                      [items]="[('employeesCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>
    <div class="row employees-page__row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 employees-page__column">
        <app-master-table #employeesTable
                          [title]="'employeesCatalog.title' | translate"
                          [columnDefinitions]="columnDefinitions"
                          [dataSource]="dataSource"
                          [filters]="tableFilters"
                          [isLoading]="isLoading"
                          [tableMaxHeight]="'100%'"
                          [useServerData]="true"
                          [totalItems]="totalItems"
                          [currentPage]="currentPage"
                          [pageSize]="pageSize"
                          [pageSizeOptions]="[15, 25, 50, 100, 200]"
                          [searchValue]="searchValue"
                          [showCheckbox]="true"
                          [disableRowClickToEdit]="true"
                          [enableRowClick]="false"
                          [exportFileName]="'employees'"
                          [actions]="actions"
                          (add)="handleAdd()"
                          (details)="handleView($event)"
                          (edit)="handleEdit($event)"
                          (delete)="handleDelete($event)"
                          (bulkDelete)="handleBulkDelete($event)"
                          (refresh)="loadData()"
                          (searchChange)="onSearchChange($event)"
                          (filtersChange)="onFiltersChange($event)"
                          (pageChange)="onPageChange($event)"
                          (actionTriggered)="handleAction($event)">
        </app-master-table>
      </div>
    </div>
  </div>
</section>
